<template>
  <div>
    <!-- Importación del Header (Navbar) -->

    <div class="container d-flex justify-content-center align-items-center min-vh-100">
      <!-- Tarjeta flotante del formulario -->
      <div class="card shadow-lg rounded-3 w-100" style="max-width: 800px;">
        <div class="card-body">
          <h2 class="titulo-formulario">Rentas</h2>
          <p class="text-center mb-4 text-muted">
            En este módulo podrás registrar las rentas de los vestidos, proporcionando los detalles necesarios para su gestión.
          </p>
          <form @submit.prevent="submitForm">
            <!-- Campo de búsqueda de vestido con autocompletado -->
            <div class="form-group mb-3 position-relative">
              <label for="id_vestido">ID de Vestido</label>
              <input
                type="text"
                v-model="searchTerm"
                id="id_vestido"
                class="form-control"
                placeholder="Escriba el código del vestido"
                @input="filterStock"
                required
              />
              <!-- Lista desplegable para sugerencias -->
              <ul
                v-if="filteredStock.length > 0"
                class="list-group position-absolute w-100 z-index-100"
                style="max-height: 200px; overflow-y: auto;"
              >
                <li
                  v-for="vestido in filteredStock"
                  :key="vestido.id_vestido"
                  class="list-group-item list-group-item-action d-flex align-items-center"
                  @click="selectDress(vestido)"
                >
                <img
  :src="formatImageUrl(vestido.foto_vestido)"
  alt="Imagen del vestido"
  class="me-3"
  style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;"
/>

                  <span>
                    {{ vestido.codigo_vestido }} - {{ vestido.modelo_vestido }}
                  </span>
                </li>
              </ul>
            </div>

        
            <!-- Detalles del formulario -->
            <div class="row mb-3">
  <div class="col-md-6">
    <label for="nombre_clienta">Nombre de la Clienta</label>
    <input
  type="text"
  v-model="renta.nombre_clienta"
  id="nombre_clienta"
  class="form-control"
  placeholder="Nombre de la clienta"
  required
  @input="renta.nombre_clienta = renta.nombre_clienta.toUpperCase()"
/>

  </div>
  <div class="col-md-6">
    <label for="telefono">Teléfono</label>
    <input
      type="tel"
      v-model="renta.telefono"
      id="telefono"
      class="form-control"
      placeholder="10 dígitos"
      required
      pattern="[0-9]{10}"
      maxlength="10"
      title="Debe contener exactamente 10 dígitos"
    />
  </div>
</div>


           <!-- Campo de Precio Sugerido Renta -->
           <div class="row mb-3">
  <div class="col-md-4">
    <label for="precio_sugerido_renta">Precio Sugerido</label>
    <input
      type="number"
      v-model="renta.precio_sugerido_renta"
      id="precio_sugerido_renta"
      class="form-control"
      readonly
      style="background-color: #ffeb3b; color: #000; font-weight: bold;"
      step="0.01"
    />
  </div>
  <div class="col-md-4">
    <label for="precio_rentado">Precio Renta</label>
    <input
  type="number"
  v-model.number="renta.precio_rentado"
  step="0.01"
  class="form-control"
  @blur="formatDecimal('precio_rentado')"
/>

  </div>
  <div class="col-md-4">
    <label for="anticipo">Anticipo</label>
    <input
  type="number"
  v-model.number="renta.anticipo"
  id="anticipo"
  class="form-control"
  step="0.01"
  @blur="formatDecimal('anticipo')"
/>

  </div>
</div>

          
            <div class="row mb-3">
  <div class="col-md-4">
  <label for="fecha_renta">Fecha de Renta</label>
  <input
    type="date"
    v-model="renta.fecha_renta"
    id="fecha_renta"
    class="form-control"
    required
  />
</div>

<div class="col-md-4">
  <label for="fecha_recoge">Fecha de Recogida</label>
  <input
    type="date"
    v-model="renta.fecha_recoge"
    id="fecha_recoge"
    class="form-control"
    :min="renta.fecha_renta"
    required
  />
</div>

<div class="col-md-4">
  <label for="fecha_entrega">Fecha de Entrega</label>
  <input
    type="date"
    v-model="renta.fecha_entrega"
    id="fecha_entrega"
    class="form-control"
    :min="renta.fecha_recoge"
    required
  />
</div>

</div>

  <!-- Campo de Forma de Pago -->
  <div class="form-group mb-3">
              <label for="forma_pago">Forma de Pago</label>
              <select
                v-model="renta.forma_pago"
                id="forma_pago"
                class="form-control"
                required
              >
                <option value="Efectivo">Efectivo</option>
                <option value="Transferencia">Transferencia</option>
                <option value="Tarjeta">Tarjeta</option>
              </select>
            </div>

        <!-- Campo de Ajustes (Sí / No) -->
<div class="row mb-3">
  <div class="col-md-4">
    <label>Ajustes</label>
    <div>
      <label class="me-2">
        <input type="radio" v-model="renta.ajustes" value="si" required /> Sí
      </label>
      <label>
        <input type="radio" v-model="renta.ajustes" value="no" required /> No
      </label>
    </div>
  </div>

  <!-- Solo se muestra si renta.ajustes es 'si' -->
  <div class="col-md-4" v-if="renta.ajustes === 'si'">
    <label for="descripcion_ajustes">Descripción</label>
    <input
      type="text"
      v-model="renta.descripcion_ajustes"
      id="descripcion_ajustes"
      class="form-control"
      placeholder="Ej. Ajustar tirantes"
    />
  </div>

  <div class="col-md-4" v-if="renta.ajustes === 'si'">
    <label for="costo_ajustes">Costo Ajustes</label>
    <input
  type="number"
  v-model.number="renta.costo_ajustes"
  id="costo_ajustes"
  class="form-control"
  step="0.01"
  @blur="formatDecimal('costo_ajustes')"
/>

  </div>
</div>


            <div class="d-flex justify-content-center">
              <button
                type="submit"
                class="btn btn-primary btn-lg w-50 transition-all duration-300 hover:scale-105"
              >
                Agregar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Modal para mostrar el vestido seleccionado -->
<div v-if="showModal" class="modal-backdrop">
  <div class="modal-content">
    <h5 class="text-primary text-center">Vestido Seleccionado</h5>
    <img
  v-if="selectedDress && selectedDress.foto_vestido"
  :src="formatImageUrl(selectedDress.foto_vestido)"
  alt="Imagen del vestido"
  class="miniatura-modal"
/>


    <p><strong>Código:</strong> {{ selectedDress.codigo_vestido }}</p>
    <p><strong>Modelo:</strong> {{ selectedDress.modelo_vestido }}</p>
    <p><strong>Descripción:</strong> {{ selectedDress.descripcion }}</p>
    <p><strong>Color:</strong> {{ selectedDress.color }}</p>
    <p><strong>Talla:</strong> {{ selectedDress.talla }}</p>
    <p><strong>Costo Renta:</strong> ${{ selectedDress.costo_renta }}</p>
    <div class="text-center mb-3">
      <img
  v-if="vestido && vestido.foto_vestido"
  :src="formatImageUrl(vestido.foto_vestido)"
  alt="Imagen del vestido"
  class="me-3"
  style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;"
>

    </div>
    <div class="text-center">
      <button class="btn btn-danger" @click="showModal = false">Cerrar</button>
    </div>
  </div>
</div>

  </div>


</template>

<script>
import axios from "axios";
import baseUrl from "../api";
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import { mapState } from 'vuex';


export default {
  name: "RentasVestido",
  components: {
  },
  data() {
    const zonaUsuario = moment.tz.guess(); // por ejemplo, "America/Mexico_City" o "America/Los_Angeles"

    const hoy = moment().tz(zonaUsuario).format("YYYY-MM-DD");

    return {
      fechaHoy: hoy, // 👉 necesaria para usar en los inputs
      renta: {
        id_vestido: "",
        nombre_clienta: "",
        telefono: "",
        fecha_renta: hoy, // inicializa con hoy directamente
        fecha_recoge: "",
        fecha_entrega: "",
        ajustes: "",
        descripcion_ajustes: "",
        precio_rentado: "",
        forma_pago: "",
        id_usuario: this.id_usuario,
        costo_ajustes: "",
        anticipo: ""
      },
      searchTerm: "",
      stockList: [],
      filteredStock: [],
      selectedDress: null, // Vestido seleccionado
      suggestedPrice: "", // Precio sugerido de renta
          showModal: false // 👈 aquí lo agregas

    };
  },
  methods: {
    formatFechaLarga(fecha) {
  if (!fecha) return '';
  const meses = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];
  const [año, mes, día] = fecha.split("-");
  return `${día} ${meses[parseInt(mes) - 1]} ${año}`;
}
,
    formatImageUrl(filename) {
    return `${baseUrl}/${filename}`;
  },
    resetForm() {
      const zonaUsuario = moment.tz.guess();
      const hoy = moment().tz(zonaUsuario).format("YYYY-MM-DD");
  this.renta = {
    id_vestido: "",
    id_usuario:"",
    nombre_clienta: "",
    telefono: "",
    fecha_renta: hoy, // ✅ ahora sí con valor por default correcto
    fecha_recoge: "",
    fecha_entrega: "",
    ajustes: "",
    descripcion_ajustes: "",
    precio_rentado: "",
    forma_pago: "",
    costo_ajustes: "",
    anticipo: "",
    precio_sugerido_renta: ""
  };
  this.selectedDress = null;
  this.searchTerm = "";
  this.filteredStock = [];
  this.showModal = false;
}
,
    formatDecimal(field) {
    if (this.renta[field] !== null && this.renta[field] !== "") {
      this.renta[field] = parseFloat(this.renta[field]).toFixed(2);
    }
  },
    async fetchStock() {
      try {
        const response = await axios.get(`${baseUrl}/api/stock`);
        console.log("Datos recibidos del inventario:", response.data);
        this.stockList = response.data;
        if (this.selectedDress) {
          const selectedDress = this.stockList.find(
            (vestido) => vestido.id_vestido === this.selectedDress.id_vestido
          );
          this.suggestedPrice = selectedDress ? selectedDress.costo_renta : "";
        }
      } catch (error) {
        console.error("Error al cargar el inventario:", error);
        alert("Hubo un problema al cargar el inventario. Por favor, intente nuevamente más tarde.");
      }
    },
    filterStock() {
  const term = this.searchTerm.toLowerCase();
  if (!term) {
    this.filteredStock = [];
    return;
  }

  this.filteredStock = this.stockList.filter((vestido) =>
    vestido.codigo_vestido.toLowerCase().includes(term) ||
    vestido.color.toLowerCase().includes(term) ||
    vestido.marca.toLowerCase().includes(term) ||
    vestido.modelo_vestido.toLowerCase().includes(term)

  );
},
selectDress(vestido) {
  this.selectedDress = vestido;
  this.renta.id_vestido = vestido.id_vestido;
  this.searchTerm = vestido.codigo_vestido;
  this.filteredStock = [];
  this.suggestedPrice = vestido.costo_renta;

  if (!this.renta.precio_sugerido_renta) {
    this.renta.precio_sugerido_renta = vestido.costo_renta;
  }

  this.showModal = true; // 👈 muestra el modal cuando se selecciona
}
,
clearSelection() {
  this.selectedDress = null;
  this.searchTerm = "";
  this.filteredStock = [];
  this.renta.id_vestido = "";
  this.renta.precio_sugerido_renta = ""; // ← limpiamos este campo también
  this.suggestedPrice = "";
}
,
async submitForm() {
  console.log("📤 Enviando al backend:", this.renta);
  if (this.renta.ajustes === 'no') {
  this.renta.descripcion_ajustes = null;
  this.renta.costo_ajustes = null;
}
  try {
    if (!/^\d{10}$/.test(this.renta.telefono)) {
      Swal.fire({
        icon: 'warning',
        title: 'Teléfono inválido',
        text: 'El número de teléfono debe tener exactamente 10 dígitos.',
      });
      return;
    }
// ✅ Validar fechas: entrega > recogida y mismo año
if (this.renta.fecha_recoge && this.renta.fecha_entrega) {
  const recoge = new Date(this.renta.fecha_recoge);
  const entrega = new Date(this.renta.fecha_entrega);

  if (entrega <= recoge) {
    await Swal.fire({
      icon: 'warning',
      title: 'Fechas inválidas',
      text: 'La fecha de entrega debe ser posterior a la fecha de recogida.',
    });
    return;
  }

  if (recoge.getFullYear() !== entrega.getFullYear()) {
    await Swal.fire({
      icon: 'warning',
      title: 'Año incorrecto',
      text: 'La fecha de recogida y la de entrega deben ser del mismo año.',
    });
    return;
  }
}

    if (!this.selectedDress) {
      Swal.fire({
        icon: 'warning',
        title: 'Vestido no seleccionado',
        text: 'Por favor, selecciona un vestido antes de continuar.',
      });
      return;
    }

    // Verificar si el vestido ya está rentado en esas fechas
    const verificar = await axios.post(`${baseUrl}/api/verificar-disponibilidad`, {
      id_vestido: this.renta.id_vestido,
      fecha_renta: this.renta.fecha_renta,
      fecha_recoge: this.renta.fecha_recoge,
      fecha_entrega: this.renta.fecha_entrega
    });

    if (!verificar.data.disponible) {
      Swal.fire({
        icon: 'error',
        title: 'Vestido no disponible',
        text: 'Este vestido ya está rentado en las fechas seleccionadas.',
        confirmButtonText: 'Entendido'
      });
      return;
    }

    // Registrar la renta si todo está correcto
    const response = await axios.post(`${baseUrl}/api/renta`, {
  ...this.renta,
  id_usuario: this.id_usuario ?? null // 👈 importante
});    console.log("✅ Renta registrada exitosamente", response.data);

    await Swal.fire({
  icon: 'success',
  title: 'Renta registrada exitosamente',
  html: `
    <div style="text-align: left; font-size: 14px;">
      <b>Vestido:</b> ${this.searchTerm}<br>
      <b>Clienta:</b> ${this.renta.nombre_clienta}<br>
      <b>Teléfono:</b> ${this.renta.telefono}<br>
      <b>Precio Renta:</b> $${parseFloat(this.renta.precio_rentado).toFixed(2)}<br>
      <b>Anticipo:</b> $${parseFloat(this.renta.anticipo || 0).toFixed(2)}<br>
      <b>Ajustes:</b> ${this.renta.ajustes === 'si' ? this.renta.descripcion_ajustes + ` ($${parseFloat(this.renta.costo_ajustes || 0).toFixed(2)})` : 'No'}<br>
      <b>Forma de Pago:</b> ${this.renta.forma_pago}<br>
      <b style="color:deeppink">Recoge:</b> <span style="color:deeppink">${this.formatFechaLarga(this.renta.fecha_recoge)}</span><br>
<b style="color:deeppink">Entrega:</b> <span style="color:deeppink">${this.formatFechaLarga(this.renta.fecha_entrega)}</span>


    </div>
  `,
  showCancelButton: true,
  confirmButtonText: 'Enviar por WhatsApp',
  cancelButtonText: 'Cerrar',
  reverseButtons: true,
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-secondary'
  },
  buttonsStyling: false,
  preConfirm: () => {
    const reciboWhatsApp = `
*Renta Confirmada - Miss Coquette*

*Vestido:* ${this.searchTerm}
*Clienta:* ${this.renta.nombre_clienta}
*Teléfono:* ${this.renta.telefono}

*Precio Renta:* $${parseFloat(this.renta.precio_rentado).toFixed(2)}
*Anticipo:* $${parseFloat(this.renta.anticipo || 0).toFixed(2)}
*Ajustes:* ${this.renta.ajustes === 'si' ? `${this.renta.descripcion_ajustes} ($${parseFloat(this.renta.costo_ajustes || 0).toFixed(2)})` : 'No'}

*Recoge:* ${this.formatFechaLarga(this.renta.fecha_recoge)}  
*Entrega:* ${this.formatFechaLarga(this.renta.fecha_entrega)}


Gracias por elegirnos.
Miss Coquette
    `.trim();

    const mensajeCodificado = encodeURIComponent(reciboWhatsApp);
    const telefono = this.renta.telefono;
    window.open(`https://wa.me/52${telefono}?text=${mensajeCodificado}`, '_blank');

    // no cerramos el Sweet desde aquí
    return false;
  },
  // ✅ esto sí se ejecuta al cerrar el Sweet (clic en Cerrar o X)
  didClose: () => {
    this.clearSelection(); // 🧹 función para limpiar el formulario
    this.resetForm(); // ✅ también reiniciamos los campos del formulario

  }
});



    this.clearSelection();

  } catch (error) {
    console.error("Error al registrar la renta:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Hubo un problema al registrar la renta. Por favor, intenta nuevamente.',
    });
  }
},

  },
  computed: {
  ...mapState(["id_usuario"])
},

  mounted() {
    this.fetchStock();
  },
};
</script>


<style scoped>
/* Estilos personalizados */
.card {
  background-color: #ffffff;
}

.form-group {
  margin-bottom: 15px;
}

.transition-all {
  transition: all 0.3s ease;
}

.hover\:scale-105:hover {
  transform: scale(1.05);
}

/* Ajustes de estilo para mostrar las imágenes */
.list-group-item {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.position-relative {
  position: relative;
}
.list-group-item {
  cursor: pointer;
}
/* Estilos adicionales para mejorar la apariencia */
.container {
  margin-top: 10px;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
h2 {
    font-size: 28px;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
  }
  .modal-content {
  background: white;
  padding: 20px;
  border-radius: 15px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh; /* ✅ evita que ocupe toda la pantalla */
  overflow-y: auto;  /* ✅ agrega scroll interno si se necesita */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: fadeInScale 0.3s ease;
}
.modal-content h5 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.modal-content p {
  margin: 4px 0;
  font-size: 0.95rem;
}

.modal-content img {
  margin-top: 10px;
  margin-bottom: 10px;
}


@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}


.text-muted {
  font-size: 1.25rem;
}

.form-group label {
  font-weight: 600;
  color: #5a5a5a;
}

.radio-inline input {
  margin-right: 10px;
}

button {
  width: 100%;
  padding: 11px;
  margin-top: 0px;
  font-size: 1rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
  font-family: 'Karla';
  background: linear-gradient(135deg, #c36aa0, #fca2cf);
  color: white;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  transition: all 0.3s ease;
}

button:hover {
  transform: scale(1.05);
}

.card {
  width: 80%;
  max-width: 800px;
}

.min-vh-100 {
  min-height: 100vh;
}

.miniatura-modal {
  width: 40px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
}

</style>
